import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Button, Form, Input } from 'semantic-ui-react';

/**
 * Reusable site search form.
 *
 * This component owns the search behavior and Semantic UI markup only.
 * Colors, spacing, borders, and branding belong to the consuming policy.
 */
const SearchForm = ({
  action = '/search',
  autoFocus = false,
  className,
  inputId = 'site-search-input',
  inputName = 'SearchableText',
  label = 'Search',
  method = 'get',
  onEscape,
  onSubmit,
  placeholder = 'Search...',
  submitLabel = 'Search',
}) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (autoFocus) {
      inputRef.current?.focus();
    }
  }, [autoFocus]);

  const handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      onEscape?.(event);
    }
  };

  return (
    <Form
      action={action}
      className={cx('site-search', className)}
      method={method}
      onSubmit={onSubmit}
      role="search"
    >
      <label className="site-search__label" htmlFor={inputId}>
        {label}
      </label>

      <Input fluid action className="site-search__control">
        <input
          ref={inputRef}
          id={inputId}
          className="site-search__input"
          type="search"
          name={inputName}
          placeholder={placeholder}
          aria-label={label}
          onKeyDown={handleKeyDown}
        />

        <Button className="site-search__submit" type="submit">
          {submitLabel}
        </Button>
      </Input>
    </Form>
  );
};

SearchForm.propTypes = {
  action: PropTypes.string,
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  inputId: PropTypes.string,
  inputName: PropTypes.string,
  label: PropTypes.string,
  method: PropTypes.oneOf(['get', 'post']),
  onEscape: PropTypes.func,
  onSubmit: PropTypes.func,
  placeholder: PropTypes.string,
  submitLabel: PropTypes.string,
};

export default SearchForm;
